(() => {
  const init = (menu) => {
    if (menu.dataset.ngmReady === 'true') return;
    menu.dataset.ngmReady = 'true';

    const items = [...menu.querySelectorAll('[data-ngm-mega-item]')];
    let closeTimer = null;
    let pinnedItem = null;

    const cancelScheduledClose = () => {
      if (closeTimer === null) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    const setItemOpen = (item, open) => {
      item.classList.toggle('is-open', open);
      item.querySelector('.ngm-mega-trigger')?.setAttribute('aria-expanded', String(open));
    };

    const closeAll = (except = null, force = false) => {
      cancelScheduledClose();

      items.forEach((item) => {
        if (item === except) return;
        if (!force && item === pinnedItem) return;
        setItemOpen(item, false);
      });
    };

    const openItem = (item, pin = false) => {
      cancelScheduledClose();
      closeAll(item, true);
      setItemOpen(item, true);

      if (pin) pinnedItem = item;
    };

    const closeItemLater = (item) => {
      cancelScheduledClose();

      if (item === pinnedItem) return;

      closeTimer = window.setTimeout(() => {
        closeTimer = null;

        const focusIsInside = item.contains(document.activeElement);

        if (!item.matches(':hover') && !focusIsInside) {
          setItemOpen(item, false);
        }
      }, 320);
    };

    const releasePinnedItem = () => {
      pinnedItem = null;
      closeAll(null, true);
    };

    items.forEach((item) => {
      const trigger = item.querySelector('.ngm-mega-trigger');

      trigger?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (pinnedItem === item && item.classList.contains('is-open')) {
          releasePinnedItem();
          return;
        }

        pinnedItem = item;
        openItem(item, true);
      });

      item.addEventListener('mouseenter', () => {
        cancelScheduledClose();

        if (pinnedItem && pinnedItem !== item) {
          pinnedItem = null;
        }

        openItem(item, false);
      });

      item.addEventListener('mouseleave', () => {
        closeItemLater(item);
      });

      item.addEventListener('focusin', () => {
        cancelScheduledClose();

        if (pinnedItem && pinnedItem !== item) {
          pinnedItem = null;
        }

        openItem(item, false);
      });

      item.addEventListener('focusout', () => {
        closeItemLater(item);
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-ngm-mega-item]')) {
        releasePinnedItem();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const activeTrigger = pinnedItem?.querySelector('.ngm-mega-trigger');

      releasePinnedItem();
      activeTrigger?.focus();
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-ngm-menu]').forEach(init);
  };

  const initMobile = (root) => {
    if (root.dataset.ngmMobileReady === 'true') return;
    root.dataset.ngmMobileReady = 'true';

    const drawer = root.querySelector('[data-ngm-mobile-drawer]');
    const opener = root.querySelector('[data-ngm-mobile-open]');
    const closers = [...root.querySelectorAll('[data-ngm-mobile-close]')];

    let returnFocus = null;

    const focusables = () => {
      return [
        ...drawer.querySelectorAll(
          'button:not([disabled]),summary,a[href]'
        )
      ].filter((node) => node.offsetParent !== null);
    };

    const open = () => {
      document
        .querySelectorAll('[data-ngm-mobile].is-open')
        .forEach((other) => {
          if (other !== root) other.classList.remove('is-open');
        });

      returnFocus = document.activeElement;

      root.classList.add('is-open');
      document.documentElement.classList.add('ngm-drawer-open');
      opener?.setAttribute('aria-expanded', 'true');
      drawer?.setAttribute('aria-hidden', 'false');

      window.setTimeout(() => {
        drawer
          ?.querySelector('[data-ngm-mobile-close]')
          ?.focus();
      }, 40);
    };

    const close = () => {
      root.classList.remove('is-open');

      if (!document.querySelector('[data-ngm-mobile].is-open')) {
        document.documentElement.classList.remove('ngm-drawer-open');
      }

      opener?.setAttribute('aria-expanded', 'false');
      drawer?.setAttribute('aria-hidden', 'true');

      if (returnFocus instanceof HTMLElement) {
        returnFocus.focus();
      }
    };

    opener?.addEventListener('click', open);

    closers.forEach((button) => {
      button.addEventListener('click', close);
    });

    drawer?.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) {
        close();
      }
    });

    root.addEventListener('keydown', (event) => {
      if (!root.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      const nodes = focusables();

      if (!nodes.length) return;

      const first = nodes[0];
      const last = nodes[nodes.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener(
      'resize',
      () => {
        if (
          window.innerWidth >= 750 &&
          root.classList.contains('is-open')
        ) {
          close();
        }
      },
      { passive: true }
    );
  };

  const bootAll = () => {
    boot();
    document.querySelectorAll('[data-ngm-mobile]').forEach(initMobile);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', bootAll);
})();